import { render } from "./SeilzugflaechenFooter.vue?vue&type=template&id=6d6d2a69&scoped=true&ts=true"
import script from "./SeilzugflaechenFooter.vue?vue&type=script&lang=ts"
export * from "./SeilzugflaechenFooter.vue?vue&type=script&lang=ts"

import "./SeilzugflaechenFooter.vue?vue&type=style&index=0&id=6d6d2a69&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6d2a69"]])

export default __exports__